<template>
  <div class="platformSwiper">
    <div v-if="windowWidth > 767">
      <swiper class="mySwipe" :options="swiperOption" ref="videoSwiper" style=" height: 100%; padding: 5rem 0;">
        <swiper-slide><img src="@/assets/images/aboutUs/honor/2018中国CFO最佳财务共享服务奖.jpg" alt="" /></swiper-slide>
        <swiper-slide><img src="@/assets/images/aboutUs/honor/2021中国领先地智慧企业云平台.jpg" alt="" /></swiper-slide>
        <!-- <swiper-slide><img src="@/assets/images/aboutUs/honor/国旅感谢信.jpg" alt="" /></swiper-slide> -->
        <swiper-slide><img src="@/assets/images/aboutUs/honor/2019中国企业财务共享平台首选品牌厂商奖.png" alt="" /></swiper-slide>
        <swiper-slide><img src="@/assets/images/aboutUs/honor/CMMI3认证证书.png" alt="" /></swiper-slide>
        <swiper-slide><img src="@/assets/images/aboutUs/honor/ISO9001.png" alt="" /></swiper-slide>
        <swiper-slide><img src="@/assets/images/aboutUs/honor/ISO27001.png" alt="" /></swiper-slide>
        <swiper-slide><img src="@/assets/images/aboutUs/honor/2021中国企业上云数智化平台服务领军企业.png" alt="" /></swiper-slide>
        <swiper-slide><img src="@/assets/images/aboutUs/honor/高新技术企业技术.png" alt="" /></swiper-slide>
        <swiper-slide><img src="@/assets/images/aboutUs/honor/性能检测报告.png" alt="" /></swiper-slide>
      </swiper>
      <div class="swiper-pagination" slot="pagination" id="custom"></div>
      <div class="my-swiper-btn mt-5">
        <div class="swiper-btn button-prev" @click="slideTo('prev')">
        </div>
        <div class="swiper-btn button-next" @click="slideTo('next')">
        </div>
      </div>
    </div>
    <div v-else>
      <swiper class="mySwipe" :options="swiperOptions" ref="videoSwiper" style=" height: 100%; padding: 1rem 0;">
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/2018中国CFO最佳财务共享服务奖.jpg" alt="" /></swiper-slide>
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/2021中国领先地智慧企业云平台.jpg" alt="" /></swiper-slide>
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/2019中国企业财务共享平台首选品牌厂商奖.png" alt="" /></swiper-slide>
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/CMMI3认证证书.png" alt="" /></swiper-slide>
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/ISO9001.png" alt="" /></swiper-slide>
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/ISO27001.png" alt="" /></swiper-slide>
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/2021中国企业上云数智化平台服务领军企业.png" alt="" /></swiper-slide>
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/高新技术企业技术.png" alt="" /></swiper-slide>
        <swiper-slide class="swiperApp"><img class="swiperImg" src="@/assets/images/aboutUs/honor/性能检测报告.png" alt="" /></swiper-slide>
      </swiper>
      <div class="swiper-pagination1" slot="pagination"></div>
    </div>
  </div>
</template>
<style lang="scss">
.platformSwiper {
  position: relative;

  .swiper-slide {
    overflow: hidden;
    margin: auto 0;
    text-align: center;
    img {
      width: 30rem;
      transition: all 1s ease;
    }
  }
  .swiper-pagination {
    span {
      position: relative;
      cursor: pointer;

      &::before {
        content: '';
        width: 30px;
        height: 30px;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -49% 0 0 -50%;
        z-index: 10;
      }

      &::after {
        content: '';
        width: 8px;
        height: 8px;
        background-color: #959595;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        margin: -2px 0 0 -4px;
      }

      svg {
        fill: none;
        stroke-width: 2;
        stroke: #005bab;
        stroke-dasharray: 100;
        transform: rotate(-90deg);
      }

      &.swipe-pagination-customs-active {
        &::after {
          background-color: #005bab;
        }
      }
    }

    .swipe-pagination-customs {
      margin-left: 20px;
    }

    .swipe-pagination-customs-active {
      animation: slide 5s ease;
    }

  }

  @keyframes slide {
    0% {
      stroke-dashoffset: 100;
    }

    100% {
      stroke-dashoffset: 0;
    }
  }

  .button-prev {
    position: absolute;
    top: 40%;
    left: -5%;
    z-index: 5;
    width: 60px;
    height: 60px;
    opacity: 0.6;
    transform: scale(0.8);
    cursor: pointer;
    background: url("../../../assets/images/aboutUs/btn-L.png") no-repeat;

    &:hover {
      background: url("../../../assets/images/aboutUs/btn-L-H.png") no-repeat center;

    }
  }

  .button-next {
    position: absolute;
    top: 40%;
    right: -5%;
    z-index: 5;
    width: 60px;
    height: 60px;
    opacity: 0.6;
    transform: scale(0.8);
    cursor: pointer;
    background: url("../../../assets/images/aboutUs/btn-R.png") no-repeat;

    &:hover {
      background: url("../../../assets/images/aboutUs/btn-R-H.png") no-repeat center;

    }
  }
}
.appLeft{
  left: -1% !important;
}
.appRight{
  right: -1% !important;
}
.swiperApp{
  width: 370px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiperImg{
  width: 30rem;
}
</style>

<script>
import "swiper/dist/css/swiper.css"
import { swiper, swiperSlide } from "vue-awesome-swiper"
export default {
  name: "platformSwiper",
  components: { swiper, swiperSlide },
  data() {
    return {
      swiperOption: {
        speed: 1500,
        slidesPerView: 4,
        centeredSlides: false,
        loop: true,
        autoplay: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          type: "custom",
          renderCustom: function (swiper, current, total) {
            var paginationHtml = ""
            for (var i = 0; i < total; i++) {
              if (i === current - 1) {
                paginationHtml +=
                  '<span class="swipe-pagination-customs swipe-pagination-customs-active" data-index=' + i + '><svg width="30" height="30" viewBox="0 0 30 30"><circle id="circle" cx="15" cy="15" r="14" /></svg></span>'
              } else {
                paginationHtml +=
                  '<span class="swipe-pagination-customs" data-index=' + i + '><svg width="30" height="30" viewBox="0 0 30 30"><circle id="circle" cx="15" cy="15" r="14" /></svg></span>'
              }
            }
            return paginationHtml
          },
        },
        navigation: {
          prevButton: '.swiper-button-prev',
          nextButton: '.swiper-button-next',
        },

        // autoplayDisableOnInteraction: true,
        // allowTouchMove: true,
        // custom:'',
      },
      swiperOptions: {
        speed: 1500,
        slidesPerView: 1,
        centeredSlides: false,
        loop: true,
        autoplay: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination1",
          clickable: true,
        },
      },
      windowWidth: document.documentElement.clientWidth,
    }
  },
  mounted() {
    // this.customBox = document.getElementById("custom")
    // this.customBox.addEventListener("click", this.handleClick, false)
    // console.log(this.customBox);
  },
  computed: {
    // 获取swiper对象
    swiper() {
      return this.$refs.videoSwiper.swiper
    }
  },
  methods: {
    // handleClick(e) {
    //   // 获取目标元素，拿到目标元素上的 index 值
    //   const current = e.target.dataset.index
    //   console.log(current, '55555');
    //   console.log(this.swiper.activeIndex, '3333');
    //   // 跳转到指定的 swiper 页面
    //   this.swiper.slideTo(current)
    // },
    // 自定义单页方法
    slideTo(type) {
      if (type === 'prev') {
        this.swiper.slidePrev()
      } else {
        this.swiper.slideNext()
      }
      setTimeout(() => {
        this.swiper.autoplay.start()
      }, 2000)
    },
  },
  destroyed() {
    // this.customBox.removeEventListener("click", this.handleClick, false)
  },
}
</script>
